import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Link from "next/link";
import { PrimaryButton, SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import Textarea from "@JohnLewisPartnership/jl-design-system/dist/elements/textarea/Textarea";
import { trackMonetateEvent } from "../../context/MonetateContext";
import styles from "./faq-feedback-form.module.scss";

function FAQFeedbackForm({ onSubmit, inContactUs, solution }) {
  const [solved, setSolved] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [noAnswer, setNoAnswer] = useState(false);
  const [comment, setComment] = useState("");
  const [hideButton, setHideButton] = useState(false);

  const SOLVED = { YES: "yes", NO: "no" };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  const handleNoAnswer = () => {
    setSolved(SOLVED.NO);
    setNoAnswer(true);
  };

  const handleHideButton = () => {
    setHideButton(true);
  };

  useEffect(() => {
    setSubmitted(false);
  }, [solution]);

  useEffect(() => {
    if (submitted || noAnswer) {
      onSubmit({ solved, comment });
    }
  }, [submitted, noAnswer]);

  const handleGetInTouchClick = () => {
    // Track the event for self-serve failure rate
    // Track this event for control group users
    const article = document.querySelector("[data-solution-id]");
    if (article) {
      trackMonetateEvent("self_serve_failure_rate");
    }
  };

  return (
    <div className={styles["faqFeedbackForm-container"]}>
      <h3 className={styles["faqFeedbackForm-title"]}>Was this answer helpful?</h3>
      {submitted ? (
        <div>
          <div className="message_c-message__1GGue faq-feedback-form_success-message__3KhHE">
            <div role="alert" dataTest="message" dataError="" className="message_c-message__inner__YSXT6">
              <div className="message_c-message__copy-container__3aq-K">
                <div className={styles.message_feedback_container}>
                  <div>
                    <svg
                      className={styles.faqTick_icon}
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="currentcolor"
                      aria-hidden="true"
                      role="img"
                    >
                      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm4.282 7l.718.663L10.154 16 7 12.888l.688-.693 2.436 2.387L16.282 8z" />
                    </svg>
                  </div>
                  <div className={styles.feedback_spacing}>
                    <h2 dataTest="message-title">Thank you for your feedback</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <form>
          {!hideButton && (
            <div className={styles["faqFeedbackform__buttons-container"]}>
              <SecondaryButton
                id="solved-yes"
                className={styles["faqFeedbackform__button--new"]}
                onClick={() => {
                  setSolved(SOLVED.YES);
                  handleSubmit();
                }}
              >
                Yes it was
              </SecondaryButton>
              <SecondaryButton
                id="solved-no"
                className={styles["faqFeedbackform__button--new"]}
                onClick={() => {
                  handleNoAnswer();
                  handleHideButton();
                }}
              >
                Not really
              </SecondaryButton>
            </div>
          )}
          {noAnswer && (
            <div className={styles["feedback-textarea-container"]}>
              {inContactUs ? (
                <p>
                  We’re sorry this answer did not help you. Please let us know why. Although we cannot reply to your
                  comments, we’ll use your feedback to improve our answers. Please do not leave any personal information
                  in this comments box. To get the right help now, call us on{" "}
                  <a href="tel:03456049049">03456 049 049</a>. We&#8217;re open 7 days a week 7am - 9pm.
                </p>
              ) : (
                <p>
                  We’re sorry this answer did not help you. Please let us know why. Although we cannot reply to your
                  comments, we’ll use your feedback to improve our answers. Please do not leave any personal information
                  in this comments box. To get the right help now,{" "}
                  <Link href="/contact-us" onClick={handleGetInTouchClick}>
                    contact us here
                  </Link>
                  .
                </p>
              )}
              <Textarea
                name="comment"
                type="text"
                value={comment}
                placeholder="How can we improve your experience?"
                onChange={e => setComment(e.target.value)}
                className={classnames(styles.faqFeedbackForm__textarea, "sessioncamexclude")}
                data-test="faq-feedback-form-textarea"
              />
              <PrimaryButton
                onClick={handleSubmit}
                disabled={!comment && true}
                className={styles["faqFeedbackForm-submit"]}
                data-test="faq-feedback-form-submit-button"
                aria-disabled={!comment && true}
              >
                Submit feedback
              </PrimaryButton>
            </div>
          )}
        </form>
      )}
    </div>
  );
}

FAQFeedbackForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  inContactUs: PropTypes.bool,
  solution: PropTypes.string.isRequired,
};

FAQFeedbackForm.defaultProps = {
  inContactUs: false,
};
export default FAQFeedbackForm;
